module.exports = __webpack_public_path__ + "img/logo.a5d5b6a5.png";